import "./WithdrawalExceedsModal.css";

import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";

import {
  BaseModal,
  type BaseModalProps,
} from "@/components/general/base-modal/BaseModal";
import { Button, Icon, Typo } from "@pepperstone/pepper-ui-kit";

const iconStyle: CSSProperties = {
  backgroundColor: "var(--color-icon-negative-default)",
  borderRadius: "50%",
  padding: "20px",
};

export const WithdrawalExceedsModal = ({
  onClose,
  ...props
}: Omit<BaseModalProps, "testId" | "children" | "onClose" | "onSubmit"> & {
  onClose: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      testId="withdrawal-exceeds-dialog"
      style={{ width: "min(550px, 90%)" }}
      title={
        <Icon size={"medium"} icon="cross" color="white" style={iconStyle} />
      }
      onClose={onClose}
      hideCloseIconOnMobile={false}
      {...props}
    >
      <div>
        <Typo elem="h3" type="heading" size="sm">
          {t("withdrawals.summary.exceeds_available_amount_dialog.title")}
        </Typo>
        <p>{t("withdrawals.summary.exceeds_available_amount_dialog.text")}</p>
      </div>
      {/* footer */}
      <div className="ps-flex ps-gap-2">
        <div style={{ marginInlineStart: "auto" }} />
        <Button
          data-testid={"withdrawal-exceeds-dialog-close-button"}
          variant={"ps-btn-primary"}
          type="button"
          onClick={onClose}
          className="ps-ml-full"
        >
          {t("withdrawals.summary.exceeds_available_amount_dialog.back_button")}
        </Button>
      </div>
    </BaseModal>
  );
};
